import { useEffect, useState } from "react";
import { Reveal } from "./Reveal";

const getTimeLeft = () => {
  const now = new Date();
  const end = new Date(now.getFullYear(), now.getMonth() + 1, 1);
  const diff = Math.max(0, end - now);
  return {
    days: Math.floor(diff / 86400000),
    hours: Math.floor((diff / 3600000) % 24),
    month: end.toLocaleString("en-AU", { month: "long" }),
  };
};

const CountdownOffer = () => {
  const [t, setT] = useState(getTimeLeft());

  useEffect(() => {
    const id = setInterval(() => setT(getTimeLeft()), 60000);
    return () => clearInterval(id);
  }, []);

  return (
    <Reveal delay={0.18}>
      <p
        data-testid="countdown-offer"
        className="mx-auto inline-flex flex-wrap items-center justify-center gap-x-2 gap-y-1 rounded-full border border-red-500/30 bg-red-500/10 px-5 py-2 text-center"
      >
        <span className="font-display text-base uppercase tracking-wider text-red-300 md:text-lg">
          Only 3 spots left this month
        </span>
        <span className="text-xs font-semibold uppercase tracking-[0.14em] text-white/50">
          · books out in {t.days}d {t.hours}h
        </span>
      </p>
    </Reveal>
  );
};

export default CountdownOffer;
